<template>
   <v-container fluid class="e-min-height pa-0" >
    <v-flex xs12>
      <div class="e-bg-middle-rectangle"></div>
    </v-flex>
    <HeaderTransparent title="Perfil"/>
    <v-container class="pb-0 container-prefil">
      <v-layout row wrap >
        <v-flex xs12>
          <v-card color="white" class="primary--text elevation-0 e-block-perfil">
            <div class="e-block-perfil--image">
              <div class="e-block-perfil--image-content">
                <div class="e-block-perfil--image-content-elements">
                  <div class="e-block-perfil--image-circle e-elevation--1">
                    <img :src="require('@/assets/images/logo.png')" alt="tigre-login" >
                  </div>
                  <v-btn class="e-block-perfil--image-icon e-elevation--1">
                    <img src="../../assets/images/perfil/camera.svg"/>
                  </v-btn>
                </div>
              </div>
            </div>
            <v-card-text class="pt-5">
              <h3 class="mb-2 e-card--title-big" style="color: #213536;">{{ user.email }}</h3>
            </v-card-text>
            <v-progress-circular v-if="loading" :size="50" color="primary" indeterminate></v-progress-circular>
            <v-card-text 
            v-if="!loading"
            class="e-block-perfil-text px-4">
              <div class=" e-block-perfil-text-fila">
                <div class="e-block-perfil-text-number">
                  <span><b>{{ currentUnit }}</b></span>
                </div>
                <div class="secondary--text text-xs-left">
                  <p class="mb-0">{{ progress }}% de la Unidad {{ currentUnit }}</p>
                  <p class="mb-0"><v-progress-linear  :value="progress" color="primary" height="5" ></v-progress-linear></p>
                </div>
              </div>
              <div class="py-3  e-block-perfil-text-info">
                <div>
                  <img src="../../assets/images/perfil/lessons-1.svg" alt="">
                </div>
                <div class="secondary--text text-xs-left d-flex align-center">{{ totalLessons }} lecciones completadas</div>
              </div>
              <!-- <div class="e-block-perfil-text-info">
                <div>
                  <img src="../../assets/images/unit/checkpractica.svg" alt="" style="width: 36px;">
                </div>
                <div class="secondary--text text-xs-left d-flex align-center">{{ totalPractice }} Practicas completadas</div>
              </div> -->
              <div class="e-block-perfil-text-info">
                <div>
                  <img src="../../assets/images/perfil/lessons.svg" alt="">
                </div>
                <div class="secondary--text text-xs-left d-flex align-center">{{ currentUnit - 1 }} Unidades completadas</div>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-container>
</template>
<script>
import { storeFirebase } from "../../store/firebase";

export default {
  data() {
    return {
      loading: true,
      currentUnit: 0,
      progress: 10,
      userEmail: '',
      totalGrammar: 0,
      totalLessons: 0,
      totalPractice: 0
    }
  },
  created () {
    this.loadProgress()
  },
  computed: {
    user () {
      return storeFirebase.getters.user
    }
  },
  methods: {
    loadProgress () {
      const localPractices = storeFirebase.getters.loadedPractice
      const progress = storeFirebase.getters.userProgress
      const unitNumber = progress.count.units;
      this.currentUnit = unitNumber
      const currentUnitName = 'unit_' + unitNumber
      const currentProgress = progress.units[currentUnitName]
      this.progress = Math.round(currentProgress)
      let sumaGrammar = 0
      let sumaLessons = 0
      const totalIndex = (unitNumber > 1 ? (unitNumber - 1) : unitNumber)
      for(let index = totalIndex; index > 0; index--) {
        const unitName = 'unit_' + index
        const grammar = progress.grammar[unitName]
        for(let indexGrammar in grammar) {
          const nameGrammar = grammar[indexGrammar]
          if (indexGrammar > 0) {
            if (nameGrammar.lessonsIsFull) {
              sumaLessons += nameGrammar.totalLesson
            }
          } else {
            sumaGrammar += nameGrammar.totalGrammar
          }
        }
      }
      const currentGrammar = progress.grammar[currentUnitName]
      let lastGrammar = sumaGrammar
      let lastLesson = sumaLessons
      for(let index in currentGrammar) {
        const grammar = currentGrammar[index]
        if (index > 0) {
          if (grammar.lessonsIsFull) {
            lastGrammar += 1
            const nameGrammar = 'grammar_' + lastGrammar
            const valueGrammar = grammar[nameGrammar]
            if (valueGrammar === 100) {
              sumaGrammar += 1
              sumaLessons += grammar.totalLesson
            } else {
              for(let indexLesson = 0; indexLesson < grammar.totalLesson; indexLesson++) {
                lastLesson += 1
                const nameLesson = 'lesson_' + lastLesson
                const valueLesson = grammar[nameLesson]
                if (valueLesson === 100) {
                  sumaLessons += 1
                }
              }
            }
          }
        }
      }
      let sumaPractice = 0
      for(let index = unitNumber; index > 0; index--) {
        const unitName = 'unit_' + index
        const currentPractice = progress.practice[unitName]
        for(let indexPractice in localPractices) {
          const namePractice = localPractices[indexPractice].nombre
          const valuePractice = currentPractice[indexPractice]
          if (valuePractice[namePractice] === 100) {
            sumaPractice++;
          }
        }
      }
      this.totalGrammar = sumaGrammar
      this.totalLessons = sumaLessons
      this.totalPractice = sumaPractice
      progress.count.grammar = sumaGrammar
      progress.count.lesson = sumaLessons
      progress.count.practice = sumaPractice
      // console.log('progress', progress);
      setTimeout(() => {
        this.loading = false
      }, 2000);
    }
  }
}
</script>
